import styled from "styled-components";

import AnimativeLoadingView from "app/pages/sales-intelligence/common-components/AnimativeLoadingView/AnimativeLoadingView";

import { StyledTopCompaniesStateWrapper } from "../TopCompaniesEmptyState/styles";

export const StyledTopCompaniesLoading = styled(StyledTopCompaniesStateWrapper)`
    padding-bottom: 16px;
`;
export const StyledTopCompaniesAnimativeLoadingView = styled(AnimativeLoadingView)`
    .animative-loading-text {
        margin-top: -22px;
    }
`;
